<template>
    <material-card class="v-card--material-stats">
        <v-card slot="offset" class="elevation-10 pa-4 light-gray" dark>
            <v-icon size="40">mdi-map-marker</v-icon>                                    
        </v-card>

        <div class="text-xs-right">
            <p class="category grey--text font-weight-light">{{title}}</p>
            <h3 class="title display-1 font-weight-light">{{description}}</h3>
        </div>

        <v-container fill-height fluid grid-list-xl>
            <v-layout wrap justify-center>  
                <doughnut-chart v-model="dataCollection" :options="doughnutOptions" />    
            </v-layout>
        </v-container>                                   
    </material-card>
</template>

<script>
import FormMixin from '@/mixin/form'
import DateMixin from '@/mixin/date'

import DashboardApi from '@/api/workspace/onboarding/dashboard.js'
import DoughnutChart from '@/components/material/Chart/DoughnutChart'

export default {
    components: {
        "doughnut-chart": DoughnutChart
    },    
    mixins: [ FormMixin, DateMixin ],     
    data () {
        return {         
            doughnutOptions: {  
                responsive: false, 
                maintainAspectRatio: false,
                legend: { display: false }
            },       
            dataCollection: {}   
        }
    },
    computed: {                                                                                                                     
        title () {
            return this.$t('Views.Onboarding.Dashboard.Resultado.vagas-por-localidade')
        },
        description () {
            return this.$t('Views.Onboarding.Dashboard.Resultado.top-10')
        },
        outros () {
            return this.$t('Views.Onboarding.Dashboard.Resultado.demais-localidades')
        },
        naoIdentificado(){
            return this.$t('Views.Onboarding.Dashboard.Resultado.nao-identificada')
        }       
    },
    async mounted(){       
        const loading = this.showLoading();
        await this.listar();
        loading.close();                
    },
    methods:{  
        async listar(){
            const self = this;
            const dashboard = await DashboardApi.listarPorLocalidade(
                this.$route.params.dataInicial, 
                this.$route.params.dataFinal, 
                this.$route.params.idPais
            ).catch(erro => self.showSnackbarError(erro.error));     

            if(dashboard.success) {
                if(dashboard.data != null){
                    let dataSet = [];
                    let dataLabel = [];
                    for(let count = 0; count < dashboard.data.length; count++){
                        if(dashboard.data[count].descricaoSAPSF == "N/A")
                            dataLabel.push(this.outros);

                        else if(dashboard.data[count].descricaoSAPSF != null)
                            dataLabel.push(`${dashboard.data[count].descricaoSAPSF} (${dashboard.data[count].codigoSAPSF})`);

                        else 
                            dataLabel.push(this.naoIdentificado);

                        dataSet.push(dashboard.data[count].quantidade);
                    }

                    this.dataCollection = {
                        type: "doughnut",
                        labels: dataLabel,
                        datasets: [
                            {
                                backgroundColor: ["#1d5cf6","#3d3d3d","#b1b1b1","#336cf6","#505050","#b8b8b8","#4a7cf7","#636363","#c0c0c0","#608cf8","#777777","#c8c8c8","#779df9","#8a8a8a","#d0d0d0","#8eadfa","#9e9e9e","#d8d8d8","#a4bdfb","#b1b1b1","#dfdfdf","#bbcefc","#c4c4c4","#e7e7e7","#d1defd","#d8d8d8","#efefef","#e8eefe","#ebebeb","#f7f7f7"],
                                data: dataSet
                            }
                        ]
                    };      
                }
            }
            else {                        
                self.showSnackbarError(dashboard.error);
                throw new Error(dashboard.error[0].userMessage);
            } 
        },            
    }
}
</script>